import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTableDrivers extends Layout {
    sourceCarrierDriver: DataSource;
    tableDrivers: Table;
}
